import { IconButton, styled } from '@mui/material';

import { IWithCSS } from '/common/models';

export const StyledIconButton = styled(IconButton)<IWithCSS>`
  ${({ css }) => css}
`;
